// extracted by mini-css-extract-plugin
export default {"base":"CommentHide_base__35thc"};